<template>
  <a-layout class='index animated fadeIn'>
    <a-card>
      <div class="mb15">
        <span class='mr15'>
          <a-button type="primary" @click='visible=true'>
            新增类目
          </a-button>
        </span>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" name='name'>
          <a-input v-model:value="search.name" :style="{width:'250px'}" placeholder="请输入类目名称"></a-input>
        </a-form-item>
        <a-form-item label="创建时间" name='time'>
          <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-dropdown-button>
            <a class="ant-dropdown-link"> 操作</a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a @click="action(record)" href="javascript:;">详情</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="action(record)" href="javascript:;">修改</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="action(record)" href="javascript:;">禁用</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="action(record)" href="javascript:;">删除</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.size" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" centered title="类目" v-model:visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" destroyOnClose>
    <a-input v-model:value="value" placeholder="Basic usage" />
  </a-modal>
</template>
<script>
import { ref, onMounted, reactive, toRefs } from "vue";
import { message, Modal } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getList } from "@/api/demo";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  name: "",
  level: undefined,
  page: 1,
  size: 10,
  time: [],
};
export default {
  components: {},
  setup(props) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([
      {
        id: "1",
        name: "John Brown",
        age: 32,
        address: "New York Park",
      },
    ]);
    const state = reactive({
      listLoading: false,
      visible: false,
      total: 1,
      valueRadio: null,
      confirmLoading: false,
    });
    let columns = [
      {
        title: "类目ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "类目名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "类目状态",
        dataIndex: "age",
        key: "age",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    // 页面跳转
    const pageLinkChange = () => {
      setPageState(getRouter().route.path, { ...search.value });
      getRouter().router.push("/agent/agent_list/detail");
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 页面筛选项重置
    const pageSearchReset = () => {
      search.value = {
        ...defSearch,
        page: search.value.page,
        size: search.value.size,
      };
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, size) => {
      search.value.page = 1;
      search.value.size = size;
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getList(values);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    const onChange = (e) => {
    };
    const handleOk = (e) => {
      state.confirmLoading = true;
      setTimeout(() => {
        Modal.destroyAll();

        state.visible = false;
        state.confirmLoading = false;
      }, 2000);
    };
    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageLinkChange,
      pageSearchChange,
      pageSearchReset,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      handleOk,
    };
  },
};
</script>